import type { ThemeProps as Props } from "models/styles/theme";
import styled from "styled-components/macro";

import { Heading3 } from "styles/elements/Headings";
import { CssFlex, CssGrid } from "styles/helpers/layout";

export const StyledBox = styled(CssGrid)<Props>`
  text-align: start;
  height: 100%;
  padding: 1rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 1px solid ${(props: Props) => props.theme.palette.neutral._900};
  background-color: ${(props: Props) => props.theme.palette.neutral.white};
  border-radius: 16px;
    ${Heading3} {
    margin: 0;
    align-self: center;
  }

  ${CssFlex} {
    align-items: center;
  }
`;
